export const state = {
  stations: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/stations/state.js